import { combineReducers } from "redux";
import {default as globalReducer} from "./redux/global/global.reducer"
import {default as orderReducer} from "./redux/order/order.reducer"

export default  combineReducers( {globalReducer,orderReducer} );
